import { render } from "./MobileLoader.vue?vue&type=template&id=c068a756&scoped=true"
import script from "./MobileLoader.vue?vue&type=script&lang=js"
export * from "./MobileLoader.vue?vue&type=script&lang=js"

import "./MobileLoader.vue?vue&type=style&index=0&id=c068a756&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c068a756"]])

export default __exports__